/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('nodeCreateFileModal', ['modalAction', '$translate', 'OfficeOnline', function(modalAction, $translate, OfficeOnline){
        return function(parent){

            var result = modalAction({}, {
                modalController: "CreateFileModalController",
                modalType: "confirm",
                modalAction: "createFile",
                modalBodyTemplate: "nodes/create_file",
                modalActionButton: $translate.instant('Create'),
                modalTitle: $translate.instant('Create new Office Online file'),
                modalOnEnter: 'ok',
                modalNotifications: true,
                resolve: {
                    parent: function () {
                        return parent;
                    }
                }});

            result.then(function(emptyFile){
                OfficeOnline.openFullscreen(emptyFile, 'edit');
            });
        }
    }]);
 
 
